import { DataTableCell, DataTableCellProps } from "@rmwc/data-table";
import React, { FC } from "react";

import style from "./style.scss";

export interface CellProps extends DataTableCellProps {
    cellContent: string | JSX.Element | undefined;
    search?(key: string): void;
}

type CellContentType = {
    key: string,
    props: { event: { rawQuery: string } }
}

const Cell: FC<CellProps> = (props: CellProps) => {
    const { cellContent, search, ...cellProps } = props;

    const cellContentKey = cellContent as CellContentType

    const filterValue = cellContentKey?.props?.event?.rawQuery

    return (
        <DataTableCell className={style.cell} {...cellProps}>
            {cellContent}
            {(cellContentKey.key === 'raw_query' && typeof search === "function") &&
                <a href={`#${filterValue}`} onClick={() => search(filterValue)}>
                    <span>Filter By Similar Query</span>
                </a>}
        </DataTableCell>
    );
};

export { Cell };
